import { MidnightQueries, Queries } from '@services';
import { EDataTableType } from './enum';
import { IQueryMidnightResponseTable, IQueryResponseTable } from './types';

export const handleGetDataBasedOnResponse = <T>(
  data: IQueryResponseTable<T> | IQueryMidnightResponseTable<T> | Queries | MidnightQueries,
  usingMidnightResponse: boolean,
  type: EDataTableType,
) => {
  switch (type) {
    case EDataTableType.DataItem:
      return usingMidnightResponse
        ? (data as IQueryMidnightResponseTable<T>)?.result
        : (data as IQueryResponseTable<T>)?.items;
    case EDataTableType.TotalCount:
      return usingMidnightResponse
        ? (data as IQueryMidnightResponseTable<T>)?.pagination?.total
        : (data as IQueryResponseTable<T>)?.totalCount || 0;
    case EDataTableType.Size:
      return (
        (usingMidnightResponse ? (data as MidnightQueries).pageSize : (data as Queries).size) || 10
      );
    case EDataTableType.SortDirection:
      return usingMidnightResponse
        ? (data as MidnightQueries).sortOrder
        : (data as Queries).sortDirection;
  }
};
